import { apiHandler } from '../api/responseHandler';
import config from '../../config';
import { quoteCreateValidator } from '../api/validation';
//import { authService } from '../auth/authService';
import type { QuoteCreateResponse } from '../../types/quoter/types';
import { APIError } from '../api/errors';
import logger from '../logging/logger';
import { useAuth } from '../../hooks/auth/useAuth';
import { triggerMismatchCheck } from '../mismatchAlert';

const componentName = 'quoteCreator';

export const createQuote = async (
    boatId: number,
    sailId: number,
    sailArea: string,
    sailCutId: string,
    isFurling: number = 0,
    userId: number
): Promise<number> => {
    try {
        // Ensure we have a valid user ID before proceeding
        if (!userId) {
            throw new Error('User ID is required to create a quote');
        }

        const requestParams = {
            userId: userId,
            boatId: Number(boatId),
            sailId: Number(sailId),
            sailCutId: Number(sailCutId),
            sailArea: Number(sailArea),
            isFurling: Number(isFurling)
        };

        logger.log('LogQuoteCreation', componentName, 'Creating quote with params:', requestParams);

        const response = await apiHandler.fetch<QuoteCreateResponse>(
            `${config.API_URL}/api/quotes/create`,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify(requestParams),
                validateFn: (data) => quoteCreateValidator.validate(data)
            }
        );

        if (response.error) throw response.error;
        if (!response.data?.quoteId) {
            throw new Error('Invalid API response: Missing quoteId');
        }

        logger.log('LogQuoteCreation', componentName, 'Quote created successfully:', response.data.quoteId);

        // Trigger mismatch check
        triggerMismatchCheck();

        return response.data.quoteId;

    } catch (err) {
        console.error('LogQuoteCreation', componentName, 'Error creating quote:', err);
        if (err instanceof APIError) throw err;
        throw new Error('Failed to create quote');
    }
};
